/* Информация о договоре */
export const getAgreementDataString = (tariffName: string, itogInMonth: number, itogInOnce: number) =>
    `${tariffName} total amount: ${itogInMonth + itogInOnce} monthly payment: ${itogInMonth} one-time payment: ${itogInOnce}`;
